import axios from "axios";
import { history } from "../Router/history";
import { chatEndpoint } from "./Constants";
import * as Encrypt from "./Encryption";

const axiosFileConfig = axios.create({
  baseURL: chatEndpoint,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

axiosFileConfig.interceptors.request.use(
  function (config) {
    const Token = Encrypt.getDecryptedToken();
    if (Token) config.headers["x-auth"] = Token;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosFileConfig;
